<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-mt-2 p-ml-4 p-mr-4 p-mb-2">
        <div class="p-formgrid p-grid p-col-12 p-ml-2">
          <div class="p-col-12 p-lg-6">
            <div class="p-formgrid p-grid">
              <div class="p-field p-col-10">
                <label class="p-mr-2">{{ $t("local_event") }}</label>
                <Button
                  @click="showResponseArea = true"
                  icon="pi pi-plus"
                  class="p-button-success"
                />
              </div>
            </div>
            <div class="p-field p-col p-mt-2" style="margin-left: -10px">
              <DataTable
                :value="responseArea_table"
                :scrollable="true"
      scrollHeight="500px"
                :paginator="true"
                :rows="5"
                dataKey="id"
                ref="dt"
                :rowHover="true"
                
                :selection.sync="selectedResponseAreaData"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
              >
                <template #empty>{{ $t("TableEmpty") }}</template>
                <Column
                  field="province_name"
                  :header="$t('province')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    <div hidden>{{ dataTable.data.tambon_id }}</div>
                    {{ dataTable.data.province_name }}
                  </template>
                </Column>
                <Column
                  field="amphur_name"
                  :header="$t('amphur')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.amphur_name }}
                  </template>
                </Column>
                <Column
                  field="tambon_name"
                  :header="$t('tambon')"
                  :sortable="true"
                  headerStyle="width: 15rem"
                >
                  <template #body="dataTable">
                    {{ dataTable.data.tambon_name }}
                  </template>
                </Column>
                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                  <template #body="dataTable">
                    <div class="p-formgrid p-grid">
                      <div class="p-field p-col">
                        <Button
                          @click="
                            // displayConfirmation = true;
                            responseAreaDelete = dataTable.data;
                            alertDisplay(responseAreaDelete)
                          "
                          icon="pi pi-trash"
                          :label="$t('deleteBtn')"
                          class="p-button-rounded p-button-danger"
                        />
                      </div>
                    </div>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>

          <div class="p-col p-ml-3 p-mt-3">
            <div class="p-formgrid p-col p-grid">
              <div class="p-field p-col-12 p-lg-5">
                <label>{{ $t("startDate") }}</label>
                <Calendar
                  dateFormat="dd/mm/yy"
                  :showButtonBar="true"
                  :monthNavigator="true"
                  :yearNavigator="true"
                  yearRange="2000:2050"
                  :locale="th"
                  id="startDate_a"
                  v-model="startDate"
                ></Calendar>
              </div>
              <div class="p-field p-col-12 p-lg-5">
                <label>{{ $t("toDate") }}</label>
                <Calendar
                  dateFormat="dd/mm/yy"
                  :showButtonBar="true"
                  :monthNavigator="true"
                  :yearNavigator="true"
                  yearRange="2000:2050"
                  :locale="th"
                  id="toDate_a"
                  v-model="toDate"
                ></Calendar>
              </div>
            </div>

            <div class="p-formgrid p-col p-grid p-mt-3">
              <div class="p-field p-col-10 p-lg-10">
                <label>{{ $t("disaster_type") }}</label>
                <MultiSelect
                  v-model="disasterTypeSelected"
                  :options="disasterTypeOptions"
                  optionLabel="system_name"
                  :placeholder="$t('placeholderSelectBox')"
                  :filter="true"
                  class="multiselect-custom"
                  :clearFilterMultiSelect="multiSelectClearFilerValue"
                >
                  <template #value="slotProps">
                    <div
                      class="item item-value"
                      v-for="option of slotProps.value"
                      :key="option.id"
                    >
                      <div>{{ option.system_name }}</div>
                    </div>
                    <template
                      v-if="!slotProps.value || slotProps.value.length === 0"
                    >
                      {{ $t("placeholderSelectBox") }}
                    </template>
                  </template>
                  <template #option="slotProps">
                    <div class="item">
                      <div class="EV_disasterOptions">{{ slotProps.option.system_name }}</div>
                    </div>
                  </template>
                </MultiSelect>
              </div>
              <div class="p-field p-col-1 p-lg-1 p-mt-4">
                <Button
                  @click="disasterTypeSelected = null
                          multiSelectClearFilerValue +=1"
                  icon="pi pi-times"
                  class="p-button-danger p-mt-2"
                />
              </div>
            </div>
            <span class="p-invalid" v-if="error_disaster == true">{{
              $t("table_validate")
            }}</span>

            <div class="p-formgrid p-grid p-col p-mt-2">
              <div class="p-col-12 p-lg-12">
                <label>{{ $t("iv_victim_status") }}</label>
                <div class="p-formgrid p-grid p-col p-mt-3">
                  <div class="p-field-checkbox p-mr-4">
                    <Checkbox
                      id="check_level_1"
                      name="check_1"
                      value="gs-99die"
                      v-model="checked"
                    />
                    <label>เสียชีวิต</label>
                  </div>
                  <div class="p-field-checkbox p-mr-4">
                    <Checkbox
                      id="check_level_12"
                      name="check_2"
                      value="gs-99hurt"
                      v-model="checked"
                    />
                    <label>บาดเจ็บ</label>
                  </div>
                  <div class="p-field-checkbox p-mr-4">
                    <Checkbox
                      id="check_level_3"
                      name="check_3"
                      value="gs-99lost"
                      v-model="checked"
                    />
                    <label>สูญหาย</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-col">
              <div class="p-formgrid p-grid p-mt-4 p-jc-end">
                <div class="p-field p-col p-mt-2">
                   <!-- <Button
                    @click="exportCSV()"
                    :label="$t('exportBtn')"
                    class="p-button-info p-mr-3"
                    style="background-color: green;"
                  /> -->
                  <Button
                    @click="clearSearchField()"
                    :label="$t('clearBtn')"
                    class="p-button-clear p-mr-3"
                  />
                  <Button
                    @click="search()
                    cou = true"
                    :label="$t('searchBtn')"
                    class="p-button-info p-mr-2"
                  />
                </div>
              </div>
            </div>
            
          </div>
        </div>
        <div class="p-formgrid p-grid p-col p-mt-1">
              <text-footer
                :data="Data_text_Footer"
                :checkShow="text_Footer"
                :countItem="table.length.toLocaleString('en-US')"
              />
        </div>
      </div>
    </Fieldset>

    <Dialog
      :modal="true"
      header="ค้นหาข้อมูลพื้นที่เกิดเหตุ"
      :visible.sync="showResponseArea"
      :style="{ width: '80%' }"
      :contentStyle="{ 'overflow-y': 'scroll' }"
    >
      <response-area-table
        @selectResponseArea="selectResponseArea_passValue"
        :parentmessage="parentmessage_area"
      ></response-area-table>
    </Dialog>

    <div class="card p-fluid p-mt-2">
       <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
      <DataTable
        :value="table"
        :scrollable="true"
      scrollHeight="500px"
        :paginator="true"
        :sortOrder="1"
        sortField="index"
        :rows="10"
        dataKey="id"
        ref="dt"
        :exportFilename = "`สรุปจำนวนผู้ประสบภัย-${date}`"
        :rowHover="true"
        :filters="filters"
        :loading="loading"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
       <!-- Doe : เพิ่ม ลำดับ 1/4  จบ sortField="index" :sortOrder="1" -->
      <template #header>
          <div class="p-grid p-col ">
            
            <!-- Doe : PDF 1/3 -->
            <div class="table-header "  style="padding: 7px;"   >
              <Button
                    
                    @click="exportCSV()"
                    :label="$t('exportBtn')"
                    class="p-button-info "
                   
                    style="background-color: green;"
                  />
            </div>
            <div class="table-header " style="padding: 7px;"  >
              <SplitButton label="ส่งออก PDF" :model="items" 
                          class="p-button-raised p-button-danger "
                          style="background-color: #f33737; "
                          ></SplitButton>
            </div>
            <!-- Doe : PDF 1/3 จบ -->

            <!-- Doe PDF เลือกได้  1/5   -->
            <div class="table-header" id="TABLE_EDIT" style="padding: 7px;"  >
                <Button
                @click="EditPDF()"
                icon="pi pi-cog"
                :label="'ตั้งค่า'"
                style="background-color: #0288D1;
                       border: 1px solid #0288D1;"
                />
            </div>
            <!-- Doe PDF เลือกได้  1/5 จบ  -->

            <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
              <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

              <!-- Doe ค้นหา  1/5 -->
              <span class="p-input-icon-left" v-if="columns_disabled && cou" >    
                    <i class="pi pi-search" />
                    <InputText
                    v-model="filter"
                    @input="searchTable()"
                    :placeholder="$t('searchHeader')"
                    />
                    
                </span>
                <span class="p-input-icon-left" v-else >
                    <i class="pi pi-search" />
                    <InputText
                    disabled
                    v-model="filter"
                    @input="searchTable()"
                    :placeholder="$t('searchHeader')"
                    />
                    
                </span>
              <!-- Doe ค้นหา  1/5 จบ-->

            </div>
          </div>
        </template>
        <!-- <template #header>
          <div class="table-header p-col-12 p-lg-3" style="margin-left: auto">
            <span class="p-input-icon-left">
              <i class="pi pi-search" /><InputText
                v-model="filters['global']"
                :placeholder="$t('searchHeader')"
              />
            </span>
          </div>
        </template> -->
        <template #empty>{{ $t("TableEmpty") }}</template>
        <!--Doe : เพิ่มลำดับ 2/4-->
        <div v-if="columns_index == true">
          <Column
            field="index"
            :header="'ลำดับ'"
            :sortable="true"
            :headerStyle="{width: '8rem',textAlign:'center'}"
          >
            <template #body="dataTable">  
              <div hidden>{{ dataTable.data.system_id }}</div>
              <div class="table_row">
                {{ dataTable.data.index }}
              </div>
              
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>
        <!--Doe : เพิ่มลำดับ 2/4 จบ-->

        <div v-if="columns_disaster_name == true">
          <Column
            field="disaster_name"
            :header="$t('disaster_type')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              {{ dataTable.data.disaster_name }}
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_P_all == true">
          <Column
            field="P_all"
            :header="$t('local_event')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.province_name != null">
                {{ dataTable.data.province_name }},
                {{ dataTable.data.amphur_name }}, {{ dataTable.data.tambon_name }}
              </div>
              <div v-else>-</div>
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_hazard == true">
          <Column
            field="hazard"
            :header="$t('amount_event_time')"
            :sortable="true"
            :headerStyle="{width: '15rem',textAlign:'center'}"
          >
            <template #body="dataTable">
              <div class="table_row">
                {{ dataTable.data.hazard }}
              </div>
              
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_status_name == true"> 
          <Column
            field="status_name"
            :header="$t('victim_status')"
            :sortable="true"
            :headerStyle="{width: '15rem',textAlign:'center'}"
          >
            <template #body="dataTable">
              <div class="table_row">
                {{ dataTable.data.status_name }}
              </div>
              
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_victim_amount == true"> 
          <Column
            field="victim_amount"
            :header="$t('amount_victim')"
            :sortable="true"
            :headerStyle="{width: '15rem',textAlign:'center'}"
          >
            <template #body="dataTable">
              <div class="table_row">
                {{ dataTable.data.victim_amount }}
              </div>
              
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

        <div v-if="columns_damage == true">  
          <Column field="damage" :header="$t('amount_damage')" 
          :sortable="true" headerStyle="width: 17rem">
            <template #body="dataTable">
              <div v-if="dataTable.data.damage != '0.00'">
                {{ dataTable.data.damage }}
              </div>
              <div v-else>-</div>
            </template>
          </Column>
        </div>
        <div v-else>
              <Column headerStyle="width: 0"></Column>
        </div>

      </DataTable>
    </div>

    <Dialog
      :modal="true"
      :header="$t('ConfirmDelete')"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px' }"
    >
      <div class="confirmation-content p-mt-3">
        <i
          class="pi pi-exclamation-triangle p-mr-3 p-mt2"
          style="font-size: 2rem"
        />
        <span>{{ $t("ConfirmDeleteSub") }}</span>
      </div>
      <template #footer>
        <Button
          :label="$t('cancelBtn')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="p-button-text"
        />
        <Button
          :label="$t('confirmBtn')"
          icon="pi pi-check"
          @click="confirmDelete()"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>

    <!-- Doe PDF เลือกได้  -->
    <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" 
    :style="{ width: '25rem' }"  
    :contentStyle="{ 'overflow-y': 'visible' }"
    > 
    <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
        <div style="margin: 2.5rem 1rem 0 1rem;">
          <div class="p-formgrid p-grid">
              <div class="p-field p-col-12">
          
                      <MultiSelect
                        v-model="columnsSelectorDialog"
                        :options="columns"
                        optionLabel="title"
                        :placeholder="$t('placeholderSelectBox')"
                        :filter="true"
                        class="multiselect-custom"
                        :clearFilterMultiSelect="multiSelectClearFilerValue"
                      >
                        <template #value="slotProps">
                          <div
                            class="item item-value"
                            v-for="option of slotProps.value"
                            :key="option.dataKey"
                          >
                            <div>{{ option.title }}</div>
                          </div>
                          <template
                            v-if="!slotProps.value || slotProps.value.length === 0"
                          >
                            {{ $t("placeholderSelectBox") }}
                          </template>
                        </template>
                        <template #option="slotProps">
                          <div class="item">
                            <div >{{ slotProps.option.title }}</div>
                          </div>
                        </template>
                      </MultiSelect>
                      <div style="margin-top: 1rem; 
                                  display:flex;
                                  justify-content: flex-end;">
                        <Button
                        @click="ClearEditPDF()
                                multiSelectClearFilerValue +=1"
                        class="p-button-clear"
                        :label="'ล้างข้อมูล'"
                        style="margin-right: 1rem;"
                        />
                        <Button
                        @click="SelectAllEditPDF()"
                        class="p-button-info"
                        :label="'เลือกทั้งหมด'"
                        

                        />
                      </div>
                      
              </div>
          </div>
        </div>
        <template #footer>
          <div>
            <Button
            @click="CloseEditPDF()"
            :label="'ยกเลิก'"
            icon="pi pi-times"
            class="p-button-text"
            />
            <Button
            @click="SaveEditPDF()"
            :label="'บันทึก'"
            icon="pi pi-check"
            class="p-button-text"
            />
          </div>
        </template>
      
      </Dialog>
       <!-- Doe PDF เลือกได้ -->

  </div>
</template>

<script>
import responseAreaTable from "../ResponseAreaTable";
// Doe : PDF 2/3 
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from "moment";
import textFooter from "../../../mixins/textFooter_Search_html"

export default {
  name: "report-victim-amount",
  components: {
    responseAreaTable,
    textFooter
  },
  data() {
    return {
      multiSelectClearFilerValue:0,
      date: moment().locale('th').add(543, 'year').format('l'),
      // Doe ค้นหา  2/5 
      filter:"",
      cou:false,
      cloneTable:[],
      // Doe ค้นหา  2/5 จบ
      dateYear:"",
      startDate: "",
      toDate: "",
      table: [],
      filters: {},
      displayConfirmation: false,
      showResponseArea: false,

      disasterTypeOptions: [],
      disasterTypeSelected: null,

      selectedResponseAreaData: null,
      responseArea_table: [],

      responseAreaDelete: null,

      checked: [],

      parentmessage_area: null,

      error_disaster: false,
      loading: false,

      // Doe PDF เลือกได้  2/5
      setPDF_Hor:"l",
      setPosition_Hor:[802,34,802,570],
      setPDF_Ver:"p",
      setPosition_Ver:[570,34,575,815],
      setPDF_Styles:"grid",
      setnamePDF:"ตารางสรุปจำนวนผู้ประสบภัย",
      setPDF_fillColor:[95,154,250],
      setPDF_Margin:{ left: 15 ,right: 15 },

      PDF_minCellWidthVer: 70,
      PDF_FontHeaderVer:12,
      PDF_FontBodyVer:10,

      PDF_BodySizeSelect:{},
      PDF_BodySize:{
                            index: {cellWidth: 35},
                            
                            hazard:{cellWidth:48},
                            
                            damage:{cellWidth:60},
      },
      
      PDF_minCellWidthHor: 70,
      PDF_FontHeaderHor:15,
      PDF_FontBodyHor:12,

      PDF_BodySizeHorSelect:{},
      PDF_BodySizeHor:{
                          index: {cellWidth: 35},

      },
      columns:[
                  {title: "ลำดับ", dataKey: "index" },
                  {title: "ประเภทสาธารณภัย", dataKey: "disaster_name" },
                  {title: "พื้นที่เกิดเหตุ", dataKey: "P_all" },
                  {title: "จำนวนเหตุการณ์(ครั้ง)", dataKey: "hazard"},
                  {title: "สถานภาพผู้ประสบภัย", dataKey: "status_name"},
                  {title: "จำนวนผู้ประสบภัยคน", dataKey: "victim_amount"},
                  {title: "มูลค่าความเสียหาย(บาท)", dataKey: "damage"},

              ],

      columnsSelector:null,
      columnsSelectorDialog:null,
      
      displayEditPDF:false,

      columns_index:true,
      columns_disaster_name:true,
      columns_P_all:true,
      columns_hazard:true,
      columns_status_name:true,
      columns_victim_amount:true,
      columns_damage:true,

      columns_disabled:true,
      GetData_ColumnsSearch:[],
      // Doe PDF เลือกได้  2/5  จบ
      // 
      text_Footer:false,
      Clone_Data_text_Footer:[],
      Data_text_Footer:[
        {
          DataName:"พื้นที่เกิดเหตุ",
          textShow:"",
        },
        {
          DataName:"จากวันที่",
          textShow:"",
        },
        {
          DataName:"ถึงวันที่",
          textShow:"",
        },
        {
          DataName:"ประเภทสาธารณภัย",
          textShow:"",
        },
        {
          DataName:"สถานภาพ",
          textShow:"",
        },
      ],
      // Doe : PDF 3/3
      items: [
				{
					label: ' แนวตั้ง',	
					command: () => {
            if(this.table == ""){
              this.$toast.add({severity:'warn', summary:'PDF', detail:'ไม่มีข้อมูล', life: 3000});
            }else{
						this.$toast.add({severity:'success', summary:'PDF', detail:'แนวตั้ง', life: 3000});

              let columns = this.columnsSelector

              const Body_setCenter = ["index","hazard","status_name","victim_amount"]
              
              const PintPDF = {
                streak:this.setPDF_Ver,
                setPosition:this.setPosition_Ver,
                PDF_Styles:this.setPDF_Styles,
                data:this.$refs.dt.processedData,
                columns:columns,
                columnsStyles:this.PDF_BodySizeSelect,
                FileName:this.setnamePDF,
                checkBody_Center:true,
                Body_Center:Body_setCenter,
                Col_FontSize:this.PDF_FontHeaderVer,
                Body_FontSize:this.PDF_FontBodyVer,
                minCell:this.PDF_minCellWidthVer,
                marginPDF:this.setPDF_Margin,
                fillColorPDF:this.setPDF_fillColor,
              }
              this.printPDF(PintPDF) 

            }  
              }
            },
			
				{
					label: 'แนวนอน',
					command: () => {
            if(this.table == ""){
              this.$toast.add({severity:'warn', summary:'PDF', detail:'ไม่มีข้อมูล', life: 3000});
            }else{
						this.$toast.add({severity:'success', summary:'PDF', detail:'แนวนอน', life: 3000});
            
           let columns = this.columnsSelector

              const Body_setCenter = ["index","hazard","status_name","victim_amount"]
              
              const PintPDF = {
                streak:this.setPDF_Hor,
                setPosition:this.setPosition_Hor,
                PDF_Styles:this.setPDF_Styles,
                data:this.$refs.dt.processedData,
                columns:columns,
                columnsStyles:this.PDF_BodySizeHorSelect,
                FileName:this.setnamePDF,
                checkBody_Center:true,
                Body_Center:Body_setCenter,
                Col_FontSize:this.PDF_FontHeaderHor,
                Body_FontSize:this.PDF_FontBodyHor,
                minCell:this.PDF_minCellWidthHor,
                marginPDF:this.setPDF_Margin,
                fillColorPDF:this.setPDF_fillColor,
              }
              this.printPDF(PintPDF) 
 
            } 
            }
          },
        ],
      // Doe : PDF 3/3 จบ
    };
  },
  watch: {
    disasterTypeOptions(val) {
      if (val != null) {
        this.disasterTypeSelected = val;
      }
    },

    disasterTypeSelected(val) {
      if (val != null) {
        this.error_disaster = false;
        if (val.length == 0) {
          this.disasterTypeSelected = null;
        }
      }
    },

    showResponseArea(val) {
      if (val == true) {
        if (this.responseArea_table.length > 0) {
          this.parentmessage_area = this.responseArea_table;
        } else {
          this.parentmessage_area = [];
        }
      }
    },

    table(val) {
      if (val.length > 0) {
        this.loading = false;
      } else {
        this.loading = false;
      }
    },
    // Doe PDF เลือกได้
    columnsSelector(val){
      
      if (val.length == 0) {
        this.table = []
      }else{
        this.table = this.cloneTable
      }
    },
  },
  async created() {

    // Doe PDF เลือกได้  4/5  
    this.columnsSelector = this.columns
      this.PDF_BodySizeSelect = this.PDF_BodySize
      this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor

      // Doe PDF เลือกได้  4/5  จบ

    
    // const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(this.toDate)
    const yy = new Date(); 
    const yyyy = parseInt( yy.getFullYear() );
    this.dateYear = yyyy
    this.startDate= new Date(yyyy,0,1);
    this.toDate = new Date();
    
    this.checked = ["gs-99die", "gs-99hurt", "gs-99lost"];
    await this.axios
      .post(`${this.$url_service}/initial/option`, {
        body: { group: "dg-02" },
      })
      .then((response) => {
        this.disasterTypeOptions = response.data.data;
      });

      this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer)

  },
  mounted() {},
  methods: {
    exportCSV() {
      if (this.table != "") {
      debugger;
      this.$refs.dt.exportCSV();
      }
    },
    selectResponseArea_passValue(variable) {
      this.showResponseArea = false;
      if (variable != null) {
        this.responseArea_table = [];
        for (let i = 0; i < variable.length; i++) {
          this.responseArea_table.push(variable[i]);
        }
      }
    },

    // Doe ค้นหา  3/6 
    searchTable(){
      this.ms = true
      if (this.filter != "") {
        // console.log("4444")
        this.table = this.cloneTable.filter((item) => {

          return (this.columns_disaster_name ? item.disaster_name.includes(this.filter) : "") ||
                 (this.columns_P_all ? item.P_all.includes(this.filter) : "") ||
                 (this.columns_hazard ? item.hazard.includes(this.filter) : "") ||
                 (this.columns_status_name ? item.status_name.includes(this.filter) : "") ||
                 (this.columns_victim_amount ? item.victim_amount.includes(this.filter) : "") ||
                 (this.columns_damage ? item.damage.includes(this.filter) : "")


      });

      for (let i = 0; i < this.table.length; i++) { 
        this.table[i]["index"] =i+1;
      }

      return (this.table)

      }else{
        // console.log("5555")
      this.table = this.cloneTable
      for (let i = 0; i < this.table.length; i++) { 
        this.table[i]["index"] =i+1;
      }
      }
      this.table = this.cloneTable
    },
    // Doe ค้นหา  3/6 จบ

    async search() {
      this.filter='';
      this.cloneTable=[];
      this.loading = true;
      var startdate, enddate;
      if (this.startDate != null && this.startDate != "") {
        const date = new Date(this.startDate);
        const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
          date
        );
        const mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
          date
        );
        const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
          date
        );
        startdate = `${ye}-${mo}-${da}`;
      } else {
        startdate = "";
      }

      if (this.toDate != null && this.toDate != "") {
        const date = new Date(this.toDate);
        const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
          date
        );
        const mo = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(
          date
        );
        const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
          date
        );
        enddate = `${ye}-${mo}-${da}`;
      } else {
        enddate = "";
      }
      if (this.disasterTypeSelected != null) {
        await this.axios
          .post(`${this.$url_service}/get/report`, {
            body: {
              topic: "get-report-victim",
              subtopic: "get-report-victim-amount",
              event: "",
              location: this.responseArea_table,
              status: this.checked,
              start_date: startdate,
              end_date: enddate,
              disaster: this.disasterTypeSelected,
            },
          })
          .then((response) => {
            this.table = response.data.data
            // Doe ค้นหา  4/6 
            this.cloneTable = response.data.data
            // Doe ค้นหา  4/6 

            // Doe : เพิ่ม ลำดับ 3/4
            for (let i = 0; i < this.table.length; i++) { 
              this.table[i]["index"] =i+1;
          }
          // Doe : เพิ่ม ลำดับ 3/4 จบ

          // Doe: รวมจังหวัด
          var data1 = this.table.map(obj => 
              data1= obj.province_name)
              
            var data2 = this.table.map(obj => 
              data2= obj.amphur_name)

            var data3 = this.table.map(obj => 
              data3= obj.tambon_name)

              // console.log('data1 ',data1);
              // console.log('data2 ',data2);
              // console.log('data3 ',data3);
          
            for (let index = 0; index < data1.length; index++) {
              // const element = data1[index];
              // const element2 = data2[index];
              // const element3 = data3[index];

              // let textAll = ''
              //     textAll += `${element}, ${element2}, ${element3}`;
              if (data1[index] == null) {
                data1[index] = "-"
              }
              const element = data1[index];

              if (data2[index] == null) {
                data2[index] = "-"
              }
              const element2 = data2[index];
              if (data3[index] == null) {
                data3[index] = "-"
              }
              const element3 = data3[index];

              let textAll = ''
                  if (element == "-" && element2 == "-" && element3 == "-" ) {
                    textAll += `-`;
                  }else{
                    textAll += `${element}, ${element2}, ${element3}`;
                  }
  
                this.table[index]["P_all"] = textAll
              }
              
              // console.log(this.table)

              this.setSearchText_Footer()

          });

          if (this.columns_disabled == true) {
            this.table = this.cloneTable
          }else{
            this.table = []
          }
          
        this.loading = false;
      } else {
        this.table = [];
        this.loading = false;
        if (this.disasterTypeSelected == null) {
          this.error_disaster = true;
        }
      }
    },
    setSearchText_Footer(){
          this.text_Footer=false;

          this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
          if (this.responseArea_table.length !== 0 ||
              this.startDate !== "" ||
              this.toDate !== "" ||
              this.disasterTypeSelected.length !== 0 ||
              this.checked.length !== 0  ) {
              for (let index = 0; index < this.Data_text_Footer.length; index++) {
                const element = this.Data_text_Footer[index];
                if(element.DataName === "พื้นที่เกิดเหตุ" && this.responseArea_table.length !== 0){
                  element.textShow = this.setArray_to_Text_PAT(this.responseArea_table,"province_name","amphur_name","tambon_name")
                }
                if(element.DataName === "จากวันที่" && this.startDate !== "" ){
                  element.textShow = this.changeDateToThai(this.startDate)
                }
                if(element.DataName === "ถึงวันที่" && this.toDate !== "" ){
                  element.textShow = this.changeDateToThai(this.toDate)
                }
                if(element.DataName === "ประเภทสาธารณภัย" && this.disasterTypeSelected.length !== 0){
                  element.textShow = this.setArray_to_Text(this.disasterTypeSelected,"system_name")
                }
                if(element.DataName === "สถานภาพ" && this.checked.length !== 0){
                  element.textShow = this.setArray_to_Text(this.checked,null)
                }

                this.text_Footer=true;
              }
          }
    },
    setArray_to_Text(data,name){
      let text = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (name !== null) {
          if (element[name] !== undefined) {
            text += element[name] + ",";
          }
        }else{
          if (element === "gs-99die") {
            text += "เสียชีวิต" + ",";
          }else if (element === "gs-99hurt") {
            text += "บาดเจ็บ" + ",";
          }else if (element === "gs-99lost") {
            text += "สูญหาย" + ",";
          }
          
        }
      }
      return text.slice(0, -1)
    },
    setArray_to_Text_PAT(data,name_P,name_A,name_T){
      let text = []
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        if (name_P !== null) {
          if (element[name_P] !== undefined) {
            text += "จังหวัด : "+element[name_P] + " ";
          }
          if (element[name_A] !== undefined) {
            text += "เขต/อำเภอ : "+element[name_A] + " ";
          }
          if (element[name_T] !== undefined) {
            text += "แขวง/ตำบล : "+element[name_T] + ",";
          }
        }else{
          text += element + ",";
        }
      }
      return text.slice(0, -1)
    },

    confirmDelete() {
      this.responseArea_table = this.responseArea_table.filter(
        (val) => val !== this.responseAreaDelete
      );
      this.displayConfirmation = false;
      this.responseAreaDelete = null;
    },

    clearSearchField() {
      this.responseArea_table = [];
      this.disasterTypeSelected = null;
      this.startDate = "";
      this.toDate = "";
      this.checked = [];
      this.table = [];
      this.error_disaster = false;
      this.multiSelectClearFilerValue +=1;
      this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer)
      this.text_Footer=false;
      // Doe ค้นหา
      this.filter='';
      this.cloneTable=[];
    },
    alertDisplay(temp) {
      this.$fire({
                    title: "ยืนยันการลบข้อมูล",
                    text: "คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?",
                    
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ตกลง',
                    cancelButtonText:'ยกเลิก',
                  }).then((result) => {
                    // console.log(temp)
                    if (result.value) {
                      // console.log("temp",temp)
                      this.confirmDelete(temp)
                    }
                  })
    },

    // Doe PDF เลือกได้  5/5  
    EditPDF(){
        this.displayEditPDF = true
        this.columnsSelectorDialog = this.columnsSelector
        
      },
      SaveEditPDF(){

        if(this.columnsSelectorDialog.length <= 4){
        this.PDF_minCellWidthVer = 120 
        this.PDF_FontHeaderVer = 12
        this.PDF_FontBodyVer = 10
       
        this.PDF_BodySizeSelect = {
          index: {cellWidth: 35},
        }

        this.PDF_minCellWidthHor = 130
        this.PDF_FontHeaderHor = 15
        this.PDF_FontBodyHor = 12

        this.PDF_BodySizeHorSelect = {
          index: {cellWidth: 35},
        }

      }else if(this.columnsSelectorDialog.length <= 6){
        
        this.PDF_minCellWidthVer = 70
        this.PDF_FontHeaderVer = 12
        this.PDF_FontBodyVer = 10
        this.PDF_BodySizeSelect = {
          index: {cellWidth: 35},
        } 

        this.PDF_minCellWidthHor = 90
        this.PDF_FontHeaderHor = 15
        this.PDF_FontBodyHor = 12
        
        this.PDF_BodySizeHorSelect = {
          index: {cellWidth: 35},
        }
      }else{
        this.PDF_minCellWidthVer = 50
        this.PDF_FontHeaderVer = 12
        this.PDF_FontBodyVer = 10
        this.PDF_BodySizeSelect = this.PDF_BodySize

        this.PDF_minCellWidthHor = 70
        this.PDF_FontHeaderHor = 15
        this.PDF_FontBodyHor = 12
        
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor
      }
        
      this.columnsSelector = this.columnsSelectorDialog

        if (this.columnsSelectorDialog.length == 0) {
          
          this.columns_index = false
          this.columns_disaster_name = false
          this.columns_P_all = false
          this.columns_hazard = false
          this.columns_status_name = false
          this.columns_victim_amount = false
          this.columns_damage = false
          this.columns_ev_sidecar_number = false

          this.columns_disabled = false
        }else if(this.columnsSelectorDialog.length == 7){
            
            this.columns_index = true
            this.columns_disaster_name = true
            this.columns_P_all = true
            this.columns_hazard = true
            this.columns_status_name = true
            this.columns_victim_amount = true
            this.columns_damage = true
            
            this.columns_disabled = true
        }  
        else{
          this.columns_disabled = true
          // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);
          
          
          let getData = []    
          // ! จัดข้อมูล
          for (let index = 0; index < this.columnsSelector.length; index++) {
            getData.push(this.columnsSelector[index].dataKey);
          }
          
          // console.log("getData",getData);

          // ! เช็คข้อมูล

          for (let index = 0; index < this.columnsSelector.length; index++) {
              const element = this.columnsSelector[index].dataKey
        
              if (element == "index") {
                this.columns_index = true
              } else if(!getData.includes("index")){
                // console.log("getData.includes(index)",getData.includes("index"))
                this.columns_index = false
              }

              if (element == "disaster_name") {
                this.columns_disaster_name = true 
              }else if(!getData.includes("disaster_name")){
                
                this.columns_disaster_name = false
              }

              if (element == "P_all") {
                this.columns_P_all = true 
              }else if(!getData.includes("P_all")){
                
                this.columns_P_all = false
              }

              if (element == "hazard") {
                this.columns_hazard = true 
              }else if(!getData.includes("hazard")){
                
                this.columns_hazard = false
              }

              if (element == "status_name") {
                this.columns_status_name = true 
              }else if(!getData.includes("status_name")){
                
                this.columns_status_name = false
              }

              if (element == "victim_amount") {
                this.columns_victim_amount = true 
              }else if(!getData.includes("victim_amount")){
                
                this.columns_victim_amount = false
              }

              if (element == "damage") {
                this.columns_damage = true
              } else if(!getData.includes("damage")){
                this.columns_damage = false
              }

          }

        }

        this.displayEditPDF = false
        this.filter = ""

      },
      CloseEditPDF(){
        this.displayEditPDF = false
      },
      ClearEditPDF(){
        this.columnsSelectorDialog = []
        
      },
      SelectAllEditPDF(){
        this.columnsSelectorDialog = this.columns
        
      },
      // Doe PDF เลือกได้  5/5 จบ

  },
};
</script>

<style scoped>

.table_row{
  text-align: center;
}

@media screen and (min-width: 819px) and (max-width: 1200px)  {
  #Search{
      width: 20rem;
    }
}
/* // Doe PDF เลือกได้ */
#TABLE_EDIT{
    width: 149px;
  }
@media screen and (max-width: 818px) {
    #Search{
      width: 100%;
    }
}
@media screen and (max-width: 430px) {
  .EV_disasterOptions{
  width: 14.5rem;
  overflow-y:scroll;
  }
  .EV_disasterOptions::-webkit-scrollbar {
    width: 0;
    height: 1px;
    
  }

  .EV_disasterOptions::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1); 
      
      
  }

  .EV_disasterOptions::-webkit-scrollbar-thumb {
      
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2); 
      
  }
}
.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
.p-multiselect {
  // min-width: 18rem;
  max-width: 50rem;
  // width: fit-content;
}
@media screen and (max-width: 1540px) {
    .p-multiselect {
        max-width: 40rem !important
    }
}

@media screen and (max-width: 640px) {
    .p-multiselect {
        max-width: 10rem !important
    }
}

.multiselect-custom {
  // Doe PDF เลือกได้
  width: 100%;
  .p-multiselect-label:not(.p-placeholder) {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    
  }
  .item {
    display: flex;
    align-items: center;
  }
  .item-value {
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 3px;
    display: inline-flex;
    margin-right: 0.5rem;
    background-color: var(--primary-color);
    color: var(--primary-color-text);
  }
}
</style>
